import React from 'react';
import { useCalendarNavigation } from '../context/CalendarNavigationContext';

const MobileNavigation = ({
  prevLabel = '‹',
  nextLabel = '›',
  className = '',
}) => {
  const {
    weekLabel,
    goToPrevWeek,
    goToNextWeek,
  } = useCalendarNavigation();

  return (
    <div className={`calendar-mobile__navigation ${className}`}>
      <button
        type="button"
        className="calendar-mobile__nav-btn"
        onClick={goToPrevWeek}
        aria-label="Poprzedni tydzień"
      >
        {prevLabel}
      </button>

      <div className="calendar-mobile__nav-current">
        {weekLabel}
      </div>

      <button
        type="button"
        className="calendar-mobile__nav-btn"
        onClick={goToNextWeek}
        aria-label="Następny tydzień"
      >
        {nextLabel}
      </button>
    </div>
  );
};

export default MobileNavigation;
